module.exports = "/packs/banner_pc_webdesigner-9367b7005453bdd76eeb2cc708591314.png";